'use strict';
export module Utils {
    /**
     * Transforms a single level Json dataset to a query parameter string
     * @param data Single level Json dataset to convert
     */
    export function TransformJsonToFormData(data: Object) {
        var db: string[] = [];
        for (var prop in data) {
            if (!data.hasOwnProperty(prop))
                continue;
            db.push(`${encodeURIComponent(prop)}=${encodeURIComponent(data[prop])}`)
        }
        return db.join("&").replace(/%20/g, "+");
    }
    /**
     * Iterate over all properties of type P on a given object and apply a function to each
     * @param  {any} object target object
     * @param  {(property:P, key:string) => void } apply function to apply
     * @param  {(property:P, key:string) => boolean = _ => true} filter optional filter function, return false to exclude property
     */
    export function forEachProperty<P>(object: any, apply: (property: P, key: string) => void, filter: (property: P, key: string) => boolean = _ => true) {
        for (var key in object) {
            var prop: P = object[key];
            if (filter(prop, key))
                apply(prop, key);
        }
    }

    export function forEachKey<T>(dict: { [key: string]: T }, apply: (property: T, key: string) => void, filter: (property: T, key: string) => boolean = _ => true) {
        return forEachProperty(dict, apply, filter);
    }

    /**
     * Safely get the value of a nested property, or 'undefined' on error
     * @param object target
     * @param getter property accesser
     */
    export function getNestedPropertyValue<T, V>(object: T, getter: (object: T) => V): V {
        try {
            return getter(object);
        } catch (_) {
            return undefined;
        }

    }
}

///Generic extensions
if (!(<any>String.prototype).startsWith) {
    (<any>String.prototype).startsWith = function (searchString, position) {
        position = position || 0;
        return this.substr(position, searchString.length) === searchString;
    };
}